module.exports = __webpack_public_path__ + "static/media/user-profile.0fb0d83f.svg";